const features = [
  {
    icon: "ri-camera-line",
    title: "観光の合間に",
    desc: "umieや神戸ウォーターフロント利用時に立ち寄りやすい！",
  },
  {
    icon: "ri-parent-line",
    title: "家族で楽しめる",
    desc: "フードコートで気軽に利用しやすく、ファミリーでも入りやすい！",
  },
  {
    icon: "ri-leaf-line",
    title: "スパイス香る",
    desc: "食欲をそそる香りと満足感あふれるカレー！",
  },
  {
    icon: "ri-anchor-line",
    title: "港町らしい個性",
    desc: "神戸らしい世界観を感じるデザインとブランド体験！",
  },
];

export default function Features() {
  return (
    <section id="feature" className="relative py-20 md:py-24 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-3 mb-3">
            <span className="h-px w-8 bg-primary-500" />
            <span className="font-label tracking-widest text-primary-600 text-sm">
              FEATURE
            </span>
            <span className="h-px w-8 bg-primary-500" />
          </div>
          <h2 className="font-heading font-black text-3xl md:text-4xl text-foreground-950">
            KOBEミナトマチカレーの<span className="text-primary-600">特徴</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {features.map((f) => (
            <div
              key={f.title}
              className="bg-background-50 rounded-xl p-5 md:p-6 text-center border border-background-200 hover:-translate-y-1 transition-transform"
            >
              <div className="mx-auto mb-4 w-16 h-16 md:w-20 md:h-20 rounded-full bg-accent-500 text-secondary-900 flex items-center justify-center">
                <i className={`${f.icon} text-3xl md:text-4xl`}></i>
              </div>
              <h3 className="font-heading font-black text-foreground-950 text-base md:text-lg mb-2">
                {f.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-700 leading-relaxed">
                {f.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}